import { DocumentSummary } from "./document";

/** Who performed a Good Faith Exam. */
export enum GFESource {
  SPAKINECT = "SPAKINECT",
  QUALIPHY = "QUALIPHY",
  IN_HOUSE = "IN_HOUSE",
}

/** Where an exam stands, the same for every source. */
export enum GFEExamStatus {
  REQUESTED = "REQUESTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  REJECTED = "REJECTED",
  NOT_COMPLETED = "NOT_COMPLETED",
  CANCELLED = "CANCELLED",
}

/** Which catalog a GFE item or service requirement names. */
export enum GFERefKind {
  SPAKINECT_TREATMENT = "SPAKINECT_TREATMENT",
  QUALIPHY_EXAM = "QUALIPHY_EXAM",
  IN_HOUSE_TREATMENT = "IN_HOUSE_TREATMENT",
}

/** What an exam decided for one treatment. Deferred = declined. */
export enum GFEItemOutcome {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  CONDITIONAL = "CONDITIONAL",
  DEFERRED = "DEFERRED",
}

export interface GFEItemDetail {
  id: string;
  refKind: GFERefKind;
  ref: string;
  label: string;
  outcome: GFEItemOutcome;
  conditionNote: string | null;
}

export interface PatientGFEDetail {
  id: string;
  patientId: string;
  source: GFESource;
  examStatus: GFEExamStatus;
  providerStatus: string | null;
  createdDate: string;
  updatedDate: string | null;
  examDate: string | null;
  validUntil: string | null;
  isExpired: boolean;
  visitLink: string | null;
  eventId: string | null;
  locationId: string | null;
  noteId: string | null;
  examiningProviderId: string | null;
  examiningProviderName: string | null;
  document: DocumentSummary | null;
  items: GFEItemDetail[];
  /** In-house, while in progress: what the exam still waits on. */
  waitingOn: "UNMARKED_TREATMENTS" | "SIGN_OFF" | "CO_SIGN" | null;
}

export interface ServiceGFERequirement {
  refKind: GFERefKind;
  ref: string;
  autoRequest: boolean;
}

export interface GFETreatment {
  id: string;
  name: string;
  displayOrder: number;
  isArchived: boolean;
}

export interface InHouseGFEContext {
  templateIds: string[];
  defaultTemplateId: string | null;
  treatmentIds: string[];
}

/** One row of a GFE_CLEARANCE answer (NoteAnswer.data.value.rows). */
export interface GFEClearanceRow {
  treatmentId: string;
  outcome: GFEItemOutcome;
  conditionNote?: string | null;
  /** The name when the row was saved, for readers who can't load the treatment list. */
  treatmentName?: string;
}

/** A GFE_CLEARANCE answer (NoteAnswer.data.value). */
export interface GFEClearanceValue {
  rows: GFEClearanceRow[];
  validityDays?: number;
}

/** Whether a patient's in-house GFEs cover an appointment, judged at its start. */
export interface InHouseGFEVisitCoverage {
  treatmentIds: string[];
  coveredTreatmentIds: string[];
}
